import { EventTypes, track, PageSource } from '@mc/track-event'

export const ACTIONS = {
  TRAILER: 'Trailer',
  SAMPLE: 'Sample',
  SHARE: 'Share',
}

export interface TrackProps {
  eventName:
    | typeof EventTypes.COURSE_MARKETING_CLICK
    | typeof EventTypes.EPISODE_PAGE_CLICK
  slug: string | undefined | null
  pageCategory: 'class' | 'episode'
  pageSource: typeof PageSource.CLASS_PAGE | typeof PageSource.EPISODE_PAGE
}

export const trackAction = (
  { slug, pageCategory, eventName }: TrackProps,
  action: (typeof ACTIONS)[keyof typeof ACTIONS],
) => {
  track(eventName, {
    [pageCategory]: slug,
    category: `${pageCategory}-navigation`,
    location: 'hero',
    action,
    page_path: window.location.pathname,
    page_category: pageCategory,
  })
}

const MODAL_TYPE = 'episode_get_notified'
const MODAL_LOCATION = 'episode_coming_soon_hero'

export const trackModalViewed = ({
  episodeSlug,
  slug,
}: {
  episodeSlug: string | null | undefined
  slug: string | null | undefined
}) => {
  track(EventTypes.MODAL_VIEWED, {
    modal_type: MODAL_TYPE,
    page_source: PageSource.EPISODE_PAGE,
    location: MODAL_LOCATION,
    episode: episodeSlug,
    class: slug,
  })
}

export const trackModalClosed = ({
  episodeSlug,
  slug,
}: {
  episodeSlug: string | null | undefined
  slug: string | null | undefined
}) => {
  trackModalClicked({ episodeSlug, slug, action: 'Close' })
}

export const trackModalClicked = ({
  episodeSlug,
  slug,
  action,
}: {
  episodeSlug: string | null | undefined
  slug: string | null | undefined
  action: string
}) => {
  track(EventTypes.MODAL_CLICKED, {
    modal_type: MODAL_TYPE,
    page_source: PageSource.EPISODE_PAGE,
    location: MODAL_LOCATION,
    episode: episodeSlug,
    class: slug,
    action,
  })
}
